import { useState } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

interface DeleteConfirmationProps {
  header: string;
  description?: string;
  resourceName: string;
  onDelete: () => void;
}

const DeleteConfirmation = ({
  header,
  description,
  resourceName,
  onDelete,
}: DeleteConfirmationProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");

  const handleDelete = () => {
    onDelete();
    setIsDialogOpen(false);
    setConfirmText("");
  };

  return (
    <>
      <Box>
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={() => setIsDialogOpen(true)}
          sx={{
            borderRadius: 1,
            textTransform: "none",
          }}
        >
          Delete Organization
        </Button>
      </Box>

      <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Typography variant="h6" component="span" fontWeight={600}>
            {header}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {description && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {description}
            </Typography>
          )}
          <TextField
            fullWidth
            label={`Type "${resourceName}" to confirm`}
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            size="small"
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={() => setIsDialogOpen(false)}
            variant="outlined"
            sx={{
              borderRadius: 1,
              textTransform: "none",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            variant="contained"
            color="error"
            disabled={confirmText !== resourceName}
            sx={{
              borderRadius: 1,
              textTransform: "none",
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteConfirmation;
